var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{ 'rounded-circle': _vm.circle, 'avatar-image': true,  'user-picture': true, 'male': _vm.gender === 'male'},style:(_vm.imageStyle)})}
var staticRenderFns = []

export { render, staticRenderFns }